export const logo = require("../imgs/logo.png");
export const profile = require("../imgs/profile-icon.png");
export const user_icon = require("../imgs/user_img.png");
export const user_act = require("../imgs/admin-act.png");
export const device_icon = require("../imgs/device-icon.png");
export const device_act = require("../imgs/device-act.png");
export const location_icon = require("../imgs/location-icon.png");
export const location_act = require("../imgs/location-act.png");
export const toggle_on = require("../imgs/toggle-on.png");
export const toggle_off = require("../imgs/toggle-off.png");
export const logout_icon = require("../imgs/logout-icon.png");
export const company_icon = require("../imgs/company-icon.png");
export const mobile_icon = require("../imgs/mobile-icon.png");
export const email_icon = require("../imgs/email-icon.png");
export const password_icon = require("../imgs/password-icon.png");
export const delete_icon = require("../imgs/delete_icon.png");
export const edit_icon = require("../imgs/edit_icon.png");
export const eye_icon = require("../imgs/eye-icon.png");
export const view_icon = require("../imgs/view_icon.png");
export const left_arrow = require("../imgs/left_arrow.png");
export const right_arrow = require("../imgs/right-arrow.png");
export const jakusci = require("../imgs/Jakusci.png");
export const tub = require("../imgs/tub.png");
export const pool = require("../imgs/pool.png");
export const couple = require("../imgs/couple.png");
export const local = require("../imgs/local.png");
export const dash_act = require("../imgs/dash_act.png");
export const dash_icon = require("../imgs/dash_icon.png");
export const build_img = require("../imgs/build-blocks-img.png");
export const home_img = require("../imgs/home-img.png");
export const lock_dash_img = require("../imgs/lock-img.png");
export const cart_img = require("../imgs/cart-img.png");
export const properties_img = require("../imgs/properties-img.png");
export const green_house_img = require("../imgs/green-home-img.png");
export const country_img = require("../imgs/country-img.png");
export const mmc_dash_img = require("../imgs/mmc-img.png");
export const chat_img = require("../imgs/chat-img.png");
export const live_img = require("../imgs/live-img.png");
export const amount_img = require("../imgs/amount-img.png");

//Navbar
export const profile_img = require("../imgs/profile_img.png");
export const role_img = require("../imgs/role_img.png");
export const user_img = require("../imgs/user_list.png");
export const owner_img = require("../imgs/owner_list.png");
export const role_active = require("../imgs/role_active.png");
export const owner_active = require("../imgs/owner_act.png");
export const recp_img = require("../imgs/recp_img.png");
export const recp_active = require("../imgs/recp_active.png");
export const navi_img = require("../imgs/noti_img.png");
export const navi_active = require("../imgs/noti_active.png");
export const mmc_img = require("../imgs/mmc.png");
export const mmc_active = require("../imgs/mmc_active.png");
export const chat_icon = require('../imgs/chat_icon.png')
export const chat_unselect = require('../imgs/chat_unselect.png')

//Login Page
export const login_background = require("../imgs/login_back.png");
export const lock_img = require("../imgs/lock.png");

//Users
export const user_profile = require("../imgs/user_profile.png");
export const search_icon = require("../imgs/search_icon.png");

//Reception
export const white_rec = require("../imgs/white_rec.png");
export const green_rec = require("../imgs/green_rec.png");

//Masters
export const master_img = require("../imgs/master_img.png");
export const master_active = require("../imgs/master_active.png");
export const active_img = require("../imgs/active_img.png");
export const deactive_img = require("../imgs/deactivate_img.png");
export const no_image = require("../imgs/no_image.png");

// REVIEW
export const navi_review = require("../imgs/review_navi.png");
export const navi_review_active = require("../imgs/review_navi_active.png");

// BOOKED
export const booked_side = require("../imgs/Booked.png");
export const booked_side_active = require("../imgs/BookedActive.png");

//Bookings
export const booking = require("../imgs/booking.png");
export const booking_active = require("../imgs/booking_active.png");
//Bookings
export const property = require("../imgs/property.png");
export const property_active = require("../imgs/property-act.png");

//Notification
export const msg_crm = require("../imgs/msg_crm.png");

//dottedImg
export const dottedImg = require('../imgs/dottedImg.png');
